<template>
  <div class="app">
    <Sidebar />
    <main class="app__main">
      <div class="app__main-content">
        <OnboardingChecklistBanner />
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
  import Toolbar from '@/components/layout/Toolbar.vue';
  import Sidebar from '@/components/layout/Sidebar.vue';
  import OnboardingChecklistBanner from '@/components/onboarding/OnboardingChecklistBanner.vue';

  export default {
    components: {
      Toolbar,
      Sidebar,
      OnboardingChecklistBanner,
    },
  };
</script>

<style scoped lang="scss">
  .app {
    display: flex;
    min-height: calc(100vh - var(--app-alert-offset, 0px));
    background-color: var(--slate-50);

    &__main {
      flex: 1;
      min-width: 0;
      margin: 0.5rem 0.5rem 0.5rem 260px;
      transition: margin-left 0.3s ease;
      height: calc(100vh - var(--app-alert-offset, 0px) - 1rem);
      overflow-x: hidden;
      overflow-y: auto;
      padding: 1rem 1.25rem 1.5rem;
      background-color: var(--white);
      border: 1px solid var(--slate-200);
      border-radius: 0.75rem;
      box-shadow: 0 1px 2px rgba(55, 65, 81, 0.06);

      @include lg-down {
        margin: 0;
        height: auto;
        min-height: calc(100vh - var(--app-alert-offset, 0px));
        border: 0;
        border-radius: 0;
        box-shadow: none;
        // Safe area: top for notch, bottom for toolbar + home indicator
        padding: calc(1rem + env(safe-area-inset-top)) 0
          calc(64px + env(safe-area-inset-bottom) + 1rem) 0;
      }
    }

    &__main-content {
      width: 100%;
      min-height: 100%;
    }
  }

  // When sidebar is collapsed
  .app:has(.sidebar--collapsed) .app__main {
    margin-left: 72px;

    @include lg-down {
      margin-left: 0;
    }
  }
</style>
